import React, { useState, useEffect } from "react";
import { Grid, Box, TextField, Button } from '@mui/material';
import AxiosInstance from "../../../server/AxioInstance";
import { useSnackbar } from '../../../shared/context';

const SubSectorRegistreLayout = ({ handleChangeComponent, getComponent, item }) => {
    const { showSnackbar } = useSnackbar();
    const [formData, setFormData] = useState({
        description: '',
    });
    
    const handleReturnComponent = () => {
        handleChangeComponent('Consultar Sub Setores','consult');
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value.toUpperCase() }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); 

        const formDataToSend = new FormData();
        formDataToSend.append('description', formData.description);

        try {
            await AxiosInstance.post('/sector/insert-sectors', formDataToSend, { headers: { "Content-Type": "multipart/form-data" } });
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Criado com Sucesso',
                variant: 'success',
            });
            handleReturnComponent();
        } catch (error) {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Erro ao enviar a requisição: ' + error.message,
                variant: 'error',
            });
        }
    }

    const handleEdit = async () => {
        const data = {
            description: formData.description,
            item: item
        }
        try {
            await AxiosInstance.post('/sector/update-sub-sectors', data, { headers: { "Content-Type": "multipart/form-data" } });
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Atualizado com Sucesso',
                variant: 'success',
            });
            handleReturnComponent();
        } catch (error) {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Erro ao enviar a requisição: ' + error.message,
                variant: 'error',
            });
        }
    }

    useEffect(() => {
        if (item && item.description !== undefined) {
            setFormData((prevData) => ({ ...prevData, 'description': item.description.toUpperCase() }));
        }
    }, [item]);
    

    return(
        <Box m={1}>
            <form onSubmit={handleSubmit} method='POST'>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} xl={12}>
                        <TextField
                            name='description'
                            label={"Descrição do Setor"}
                            value={formData.description}
                            onChange={handleInputChange}
                            required
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <Button 
                            variant='contained' 
                            color="primary"
                            onClick={handleReturnComponent}
                            fullWidth
                        >
                            voltar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        {getComponent === 'edit' ? (
                            <Button 
                                variant='contained' 
                                color="success"
                                fullWidth
                                onClick={handleEdit}
                            >
                                editar
                            </Button>
                        ):(
                            <Button 
                                type='submit'  // Adicionando o tipo submit ao botão
                                variant='contained' 
                                color="success"
                                fullWidth
                            >
                                cadastrar
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}

export default SubSectorRegistreLayout;